<template>
  <div class="popup-photo">
    <van-uploader :after-read="afterRead" />
    <p>相册</p>
  </div>
</template>

<script>
import COS from 'cos-js-sdk-v5'
export default {
  data () {
    return {
      action: '',
      tenancyId: 1000
    }
  },
  props: ['sessionId'],
  created () {
    this.getCosObj()
  },
  methods: {
    getCosObj () {
      this.cosObj = new COS({
        getAuthorization: (options, callback) => {
          this.$http
            .post(`/scrm/v1/sd-img/m/getTxCosInfo`, {})
            .then((response) => {
              if (response.code === 1) {
                let data = JSON.parse(response.data)
                let credentials = data.credentials
                let backData = {
                  TmpSecretId: credentials.tmpSecretId,
                  TmpSecretKey: credentials.tmpSecretKey,
                  XCosSecurityToken: credentials.sessionToken,
                  ExpiredTime: data.expiredTime,
                }
                callback(backData)
              } else {
                this.$toast(`${response.msg}`)
              }
            })
        },
      })
    },
    // 文件上传
    afterRead (val) {
      let data = val.file
      if (data.size > 60 * 1024 * 1024) {
        this.$toast(`文件大小不能超过 60M`)
        return
      }
      // 父需 this.$toast.clear()
      this.$toast.loading({
        message: '发送中...',
        forbidClick: true,
      });
      let file = process.env.NODE_ENV + '/' + 'qw/' + this.tenancyId + '/' + new Date().getTime() + '/' + data.name
      this.cosObj.putObject(
        {
          Bucket: process.env.VUE_APP_FILELOAD,
          Region: 'ap-guangzhou',
          Key: file,
          Body: data
        },
        (err, res) => {
          if (res && res.statusCode === 200) {
            this.handleSuccess(res, data)
          } else {
            this.$toast(`${err.msg}`)
          }
        }
      )
    },
    handleSuccess (res, file) {
      let isfile = {
        url: decodeURI('https://' + res.Location),
        file: file
      }
      this.$emit('selectFile', isfile)
    },
  }
}
</script>

<style lang="less" scoped>
</style>
